import { Container, Store, wrap, Wrapper } from 'AppReact';
import { Checkbox } from './../../../common/molecules';
import { AddSection } from './../../../common/atoms';
import { FieldWrapper } from './../../../common/wrappers';
import device from "utils/device";
import styled from 'styled-components';
import { VehicleSection } from './vehicle';
import { switchLabel } from './../../../utilities';

const template = styled.div`
    width: 336px;
    padding: 0 24px;
    margin: 0 auto;

    @media ${device.tablet} {
        width: 594px;
    }
`
const WrappedCheckbox = wrap(Checkbox, FieldWrapper);

export const definition = {
    name: "Vehicles",
    props: { property: Store, vehicles: Store, haveVehicle: Store, selectedTabId: Store, language: Store },
    elements: [
        {
            wrapper: Wrapper(template),
            name: "Wrapper",
            elements: [
                {
                    componentSelect: switchLabel,
                    name: 'SectionTitle',
                    displayValue: ({ language }) => `${ language?.vehicle || 'Vehicles' }`,
                    bindings: ({ selectedTabId }) => selectedTabId
                },
                {
                    component: WrappedCheckbox,
                    name: 'NoVehicles',
                    bindings: ({ haveVehicle }) => ({ haveVehicle, label: 'I don\'t have a Vehicle', checked: !haveVehicle })
                },
                {
                    component: WrappedCheckbox,
                    name: 'HaveVehicles',
                    bindings: ({ haveVehicle }) => ({ haveVehicle, label: 'I have one or more Vehicles', checked: haveVehicle })
                },
                { 
                    component: VehicleSection,
                    isListOf: 'vehicles',
                    name: 'VehiclesList',
                    bindings: ({ language, vehicle, vehicles, haveVehicle, vehicleIndex }) => ({ vehicleIndex, language, vehicle, vehicles, haveVehicle })
                },
                {
                    component: AddSection,
                    name: 'AddVehicle',
                    renderIf: ({ haveVehicle, selectedTabId }) => haveVehicle && selectedTabId !== 'review',
                    isButton: true,
                    bindings: ({ vehicles }) => ({ vehicles }),
                    displayValue: ({ language }) => `+ ${language?.add_vehicle || 'Add Vehicle'}`,
                },
            ]
        },
    ],
}
const Vehicles = Container(definition);

export default Vehicles;
